import * as React from 'react';
import { Control, Field } from 'react-redux-form';
import { renderRadioButton, renderNumericNoFullWidthTextField, renderDateEdit, renderDatePicker, renderTimePicker } from '../../common/forms/FieldCreators';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import FormItem from '../forms/FormItem';
import { localizations } from '../../localization/localization';
import nameof from '../../utils/nameof';
import { RecurrenceModel } from '../../common/models/Recurrence';
import moment from 'moment';

interface DurationControlsProps {
    modifying: boolean;
    selectedType: string;
    startDate: moment.Moment;
    setStartDate: (value: moment.Moment) => void;
}

const DurationControls = ({ selectedType, modifying = false, startDate, setStartDate }: DurationControlsProps) => {
    return (
        <FormItem>
            <FormItem>
                <Grid container spacing={2}>
                    <Grid container item xs={12}>
                        <Grid item xs>
                            <Control
                                model={`.${nameof<RecurrenceModel>("startDate")}`}
                                component={renderDatePicker}
                                label={localizations.recurrence.recurrenceStartDate}
                                disabled={modifying}
                            />
                        </Grid>
                        <Grid item xs={1}>
                            <IconButton
                                aria-label={localizations.actions.next}
                                onClick={() => setStartDate(moment(startDate).add(1, "days"))}
                                disabled={modifying}>
                                    <AddIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={1}>
                            <IconButton
                                aria-label={localizations.actions.previous}
                                onClick={() => setStartDate(moment(startDate).subtract(1, "days"))}
                                disabled={modifying}>
                                    <RemoveIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                    <Grid container item xs={12}>
                        <Grid item xs>
                            <Control
                                model={`.${nameof<RecurrenceModel>("startDate")}`}
                                component={renderTimePicker}
                                label={localizations.recurrence.recurrenceStartTime}
                                disabled={modifying}
                            />
                        </Grid>
                        <Grid item xs={1}>
                            <IconButton
                                aria-label={localizations.actions.next}
                                onClick={() => setStartDate(moment(startDate).add(1, "hours"))}
                                disabled={modifying}>
                                    <AddIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={1}>
                            <IconButton
                                aria-label={localizations.actions.previous}
                                onClick={() => setStartDate(moment(startDate).subtract(1, "hours"))}
                                disabled={modifying}>
                                    <RemoveIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                </Grid>
            </FormItem>
            <FormItem>
                <Typography>{localizations.recurrence.recurrenceEndDate}</Typography>
                <Field model={`.${nameof<RecurrenceModel>("endDateMode")}`} dynamic={false}>
                    {/* <div><FormControlLabel disabled={false} control={<Control.radio model=".endDateMode" component={renderRadioButton} value="noEndDate" />} label={localizations.recurrence.noEndDate} /></div> */}
                    <div>
                        <FormControlLabel
                            control={
                                <Control.radio
                                    model={`.${nameof<RecurrenceModel>("endDateMode")}`}
                                    component={renderRadioButton}
                                    value="afterOccurrences"
                                    disabled={modifying}
                                />
                            }
                            label={
                                <div>
                                    {localizations.recurrence.occurencesPreInput}
                                    <Control.text
                                        model={`.${nameof<RecurrenceModel>("maxOccurrences")}`}
                                        component={renderNumericNoFullWidthTextField}
                                        disabled={selectedType !== "afterOccurrences"}
                                    />
                                    {localizations.recurrence.occurencesPostInput}
                                </div>
                            }
                        />
                    </div>
                    <div>
                        <FormControlLabel
                            control={
                                <Control.radio
                                    model={`.${nameof<RecurrenceModel>("endDateMode")}`}
                                    component={renderRadioButton}
                                    value="withEndDate"
                                    disabled={modifying}
                                />
                            }
                            label={
                                <div>
                                    {localizations.recurrence.untilPreInput}
                                    <Control.text
                                        disabled={selectedType !== "withEndDate"}
                                        model={`.${nameof<RecurrenceModel>("endDate")}`}
                                        component={renderDateEdit}
                                        style={{ width: 160 }}
                                    />
                                    {localizations.recurrence.untilPostInput}
                                </div>
                            }
                        />
                    </div>
                </Field>
            </FormItem>
        </FormItem>
    );
}

export default DurationControls;


// WEBPACK FOOTER //
// ./src/components/recurrence/DurationControls.tsx